import script from "./signinLogin.vue?vue&type=script&lang=js"
export * from "./signinLogin.vue?vue&type=script&lang=js"

import "./signinLogin.vue?vue&type=style&index=0&id=10982f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10982f44"]])

export default __exports__